angular.module('elfium').constant('CONTACT_FIELD_TYPES', {
	BOOLEAN: ['gg', 'ggVip', 'aktivni', 'zajemVino', 'zajemGolf', 'zajemVareni', 'zajemKultura', 'zajemSport', 'zajemPfkoEl', 'zajemPfFyz', 'zajemMalyDarek', 'zajemVelkyDarek'],
	DATE: ['narozeniny']
}).constant('CONTACT_REQUIRED_FIELDS', {
	jmeno: 'jméno',
	prijmeni: 'příjmení',
	firmaId: 'firma'
});


// WEBPACK FOOTER //
// ./src/app/components/contact/contactConstants.ts